// eslint-disable-next-line no-unused-vars
import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import { FormattedDate, FormattedMessage } from "react-intl";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { FLIGHT_WARNING_TYPE } from "app/constants";
import { getLastLegLandingDate } from "app/utils/utils";

const FLIGHT_TYPE = {
	1: "inbound",
	2: "outbound",
};

const getTakeOffDate = dateStr => {
	const date = new Date(dateStr);
	date.setDate(date.getDate() - 1);
	return date.toISOString().split("T")[0];
};

const getOrder = type => {
	switch (type) {
		case FLIGHT_WARNING_TYPE.OUTBOUND:
			return 1;
		case FLIGHT_WARNING_TYPE.INBOUND:
			return 2;
		default:
			return 3;
	}
};

const FlightWarnings = ({ warnings = [], flightType, flightData }) => {
	const sortedWarnings = warnings?.sort((a, b) => {
		const orderA = getOrder(a.flightSegmentType);
		const orderB = getOrder(b.flightSegmentType);

		return orderA - orderB;
	});

	const flightTypeForMessageKey = flightType?.toLowerCase();

	return sortedWarnings?.map((warning, index) => {
		const warningCodeForMessageKey = warning?.code?.toLowerCase();
		const messageId =
			flightTypeForMessageKey &&
			warningCodeForMessageKey &&
			`quotation.transport.${flightTypeForMessageKey}.${warningCodeForMessageKey?.replace(
				/_/g,
				"."
			)}`;

		const flightType = FLIGHT_TYPE[(warning?.flightSegmentType)] || FLIGHT_TYPE["1"];
		const landingDate = getLastLegLandingDate(flightData, flightType);
		const takeOffDate = getTakeOffDate(landingDate);

		return (
			messageId && (
				<div
					key={`warning-${index}`}
					className="quotation-flights__itinerary-warnings"
					data-testid={`flight-warnings-${index + 1}`}
				>
					<AlertMessage
						message={
							<div className="flight-warnings">
								<div className="warnings__item">
									<FormattedMessage
										id={messageId}
										values={{
											departureDate: (
												<FormattedDate
													timeZone="UTC"
													value={takeOffDate}
													month="short"
													day="2-digit"
												/>
											),
											endDate: (
												<FormattedDate
													timeZone="UTC"
													value={landingDate}
													month="short"
													day="2-digit"
												/>
											),
										}}
									/>
								</div>
							</div>
						}
						className="flight-warnings"
					/>
				</div>
			)
		);
	});
};

FlightWarnings.propTypes = {
	warnings: PropTypes.array,
	flightType: PropTypes.string,
	flightData: PropTypes.object,
};

export default memo(FlightWarnings);
